import { Link } from "react-router-dom";
import { environment } from "../../../config/environment";
import logo from "../../../res/imgs/logo-primary.png";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img src={logo} alt="BusiFarm" className="h-8 w-auto brightness-0 invert" />
            </Link>
            <p className="text-gray-400 leading-relaxed mb-6">
              Software House especializada em plataformas SaaS inteligentes para gestão empresarial e transformação digital.
            </p>
            <div className="flex gap-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center hover:bg-white/10 transition-colors"
              >
                <span className="sr-only">LinkedIn</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Produto */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Produto</h4>
            <ul className="space-y-3 text-gray-400">
              <li><Link to="/plataforma" className="hover:text-white transition-colors">Plataforma</Link></li>
              <li><Link to="/solucoes" className="hover:text-white transition-colors">Soluções</Link></li>
              <li><Link to="/tecnologia" className="hover:text-white transition-colors">Tecnologia</Link></li>
              <li><Link to="/segmentos" className="hover:text-white transition-colors">Segmentos</Link></li>
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Empresa</h4>
            <ul className="space-y-3 text-gray-400">
              <li><Link to="/empresa" className="hover:text-white transition-colors">Sobre</Link></li>
              <li><Link to="/contato" className="hover:text-white transition-colors">Contato</Link></li>
            </ul>
          </div>

          {/* Suporte */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Suporte</h4>
            <ul className="space-y-3 text-gray-400">
              <li><a href={environment.clientPortalUrl} target="_blank" rel="noreferrer" className="hover:text-white transition-colors">Área do Cliente</a></li>
              <li><Link to="/conteudo" className="hover:text-white transition-colors">Documentação</Link></li>
              <li><Link to="/contato" className="hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} BusiFarm. Todos os direitos reservados.
          </p>
          <div className="flex gap-6 text-gray-400 text-sm">
            <Link to="/contato" className="hover:text-white transition-colors">Privacidade</Link>
            <Link to="/contato" className="hover:text-white transition-colors">Termos</Link>
            <Link to="/contato" className="hover:text-white transition-colors">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
